export default __webpack_public_path__ + "static/media/modal-back.9b9161e2.svg";